<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                            >
                                Full Payroll Ledger Report
                            </v-expansion-panel-title>

                            <v-expansion-panel-text class="px-2">
                                <v-row class="py-2 justify-items-between">

                                    <v-col cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                            variant="outlined"
                                            density="compact"
                                            size="x-small"
                                            divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-printer"
                                                variant="flat"
                                                color="indigo"
                                                @click="printReport"
                                                >PRINT</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn>

                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn>
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                </v-row>

                                <div id="printable-area">
                                    <v-card class="my-2" elevation="0">
                                        <v-card-title class="bg-primary text-white text-center">
                                            <div class="w-100">
                                                <div class="text-h5 font-weight-bold">Full Payroll Ledger Report</div>
                                            </div>
                                        </v-card-title>
                                    </v-card>

                                    <v-data-table
                                    :headers="headers"
                                    :items="getSchema"
                                    :item-per-page="1"
                                    :loading="loading"
                                    :search="search"
                                    :hover="true"
                                    density="compact"
                                    hide-default-footer
                                    class="custom-bordered-table"
                                    >
                                        <template v-slot:item="{ item, index }">
                                            <tr>

                                                <td  class="text-center" >{{ ++index }}</td>
                                                <td class="text-left">{{ item.employee.code }}</td>
                                                <td class="text-left">{{ item.employee.name }}</td>
                                                <td class="text-left">{{ item.designation.name }}</td>
                                                <td class="text-left">{{ item.department.name }}</td>
                                                <td class="text-right">{{ item.basic }}</td>
                                                <td class="text-right">{{ item.home_allowance }}</td>
                                                <td class="text-right">{{ item.medical_allowance }}</td>
                                                <td class="text-right">{{ item.gross_salary }}</td>
                                                <td class="text-right">{{ item.income_tax }}</td>
                                                <td class="text-right">{{ item.total_deduction }}</td>
                                                <td class="text-right">{{ item.net_payable }}</td>
                                                <td class="text-right">{{ item.paid_amount }}</td>
                                                <td class="text-right">{{ item.remaining_amount }}</td>
                                                <td class="text-center">{{ getMonthsList[item.master.month-1].title }}</td>
                                                <td class="text-center">{{ item.master.year }}</td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </div>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, computed } from "vue";
import { toast } from "vue3-toastify";

export default {
    data: () => ({
        panel: [0],
        panel2: [0],
        search: "",
        headers: [
            { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
            { title: "Employee Code", key: "employee.code", align: "center", sortable: false },
            { title: "Name", key: "employee.name", align: "center", sortable: false, width: "140px" },
            { title: "Designation", key: "designation.name", align: "center", sortable: false },
            { title: "Department", key: "department.name", align: "center", sortable: false },
            { title: "Basic Salary", key: "basic", align: "center", sortable: false },
            { title: "Home Allowance", key: "home_allowance", align: "center", sortable: false },
            { title: "Medical Allowance", key: "medical_allowance", align: "center", sortable: false },
            { title: "Gross Salary", key: "gross_salary", align: "center", sortable: false },
            { title: "Income Tax", key: "income_tax", align: "center", sortable: false },
            { title: "Total Deduction", key: "total_deduction", align: "center", sortable: false },
            { title: "Net Payable", key: "net_payable", align: "center", sortable: false },
            { title: "Paid Amount", key: "paid_amount", align: "center", sortable: false },
            { title: "Remaining Amount", key: "remaining_amount", align: "center", sortable: false },
            { title: "Month", key: "month", align: "master.month", sortable: false },
            { title: "Year", key: "year", align: "master.year", sortable: false },   
        ],
        years: [],
        months: [
            { title: "January", value: 1 },
            { title: "February", value: 2 },
            { title: "March", value: 3 },
            { title: "April", value: 4 },
            { title: "May", value: 5 },
            { title: "June", value: 6 },
            { title: "July", value: 7 },
            { title: "August", value: 8 },
            { title: "September", value: 9 },
            { title: "October", value: 10 },
            { title: "November", value: 11 },
            { title: "December", value: 12 },
        ],
        loading: false,
    }),
    created(){
        if(this.$store.getters.getFullPayrollLedgerReport.length === 0) {
            this.loading = true;
            this.$store.dispatch("getFullPayrollLedgerReport").then((res) => {
                this.loading = false;
            })
        }
    },
    computed: {
        getSchema() {
            return this.$store.getters.getFullPayrollLedgerReport;
        },
        getYearsList() {
            const startYear = 2025;
            const currentYear = new Date().getFullYear();

            for (let y = startYear; y <= currentYear; y++) {
                this.years.push(y);
            }

            return this.years;
        },
        getMonthsList() {
            return this.months;
        },
        getFileServerUrl() {
            return this.$store.getters.getFileServerUrl || '';
        }
    },
    setup() {},
    methods: {
        titleShow(month, year) {
            if (month && year) {
                return `Full Payroll Ledger Report for ${this.getMonthsList[month-1].title}, ${year}`;
            } else if (year) {
                return `Full Payroll Ledger Report for ${year}`;
            } else if (month) {
                return `Full Payroll Ledger Report for ${this.getMonthsList[month-1].title}`;
            } else {
                return `Full Payroll Ledger Report`;
            }
        },
        printReport() {
            const printContent = document.getElementById("printable-area").innerHTML;
            
            const firstItem = this.getSchema[0];
            const companyInfo = firstItem?.branch?.company;
            
            const companyName = companyInfo?.name;
            const companyAddress = companyInfo?.address;
            const companyMobile = companyInfo?.mobile;
            const companyEmail = companyInfo?.email;
            const companyWebsite = companyInfo?.website;

            let companyLogo = '';
            if (companyInfo?.logo) {
                companyLogo = `${this.getFileServerUrl.replace(/\/$/, '')}/${companyInfo.logo}`;
            } else {
                companyLogo = `${this.getFileServerUrl.replace(/\/$/, '')}/uploads/demo_images/user.png`;
            }
            
            const printWindow = window.open("", "_blank", `width=${screen.width}, height=${screen.height}, left=0, top=0`);

            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <meta charset="UTF-8">
                    <meta name="viewport" content="width=device-width, initial-scale=1.0">
                    <title>Full Payroll Ledger Report</title>
                    <link href="https://cdn.jsdelivr.net/npm/@mdi/font@7.4.47/css/materialdesignicons.min.css" rel="stylesheet">
                    <style>
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }
                    
                    body {
                        font-family: 'Arial', sans-serif;
                        background: white;
                        margin: 0;
                        padding: 15px;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    .page-header {
                        margin-bottom: 30px;
                        width: 100%;
                    }
                    
                    .header-section {
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        width: 100%;
                        padding-bottom: 10px;
                        border-bottom: 1px solid #000;
                    }
                    
                    .company-info {
                        justify-self: start;
                    }
                    
                    .company-name {
                        color: #000;
                        font-size: 18px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin: 0 0 6px 0;
                        line-height: 1.3;
                    }
                    
                    .company-text {
                        font-size: 13px;
                        color: #333;
                        margin: 3px 0;
                        display: flex;
                        align-items: center;
                        line-height: 1.4;
                    }
                    
                    .company-text .mdi {
                        margin-right: 6px;
                        font-size: 14px;
                    }
                    
                    .logo-container {
                        justify-self: end;
                        display: flex;
                        align-items: flex-start;
                    }
                    
                    .logo-container img {
                        max-height: 70px;
                        max-width: 150px;
                        width: auto;
                        height: auto;
                        object-fit: contain;
                        display: block;
                    }
                    
                    .report-title-section {
                        text-align: center;
                        margin: 25px 0 20px 0;
                    }
                    
                    .report-title {
                        color: #000;
                        font-size: 18px;
                        font-weight: bold;
                        text-transform: uppercase;
                        margin: 0;
                        letter-spacing: 0.5px;
                    }
                    
                    .report-info {
                        display: flex;
                        justify-content: space-between;
                        margin-bottom: 15px;
                        font-size: 13px;
                        color: #333;
                    }
                    
                    .report-info-left {
                        font-weight: 500;
                    }
                    
                    .report-info-right {
                        font-weight: 500;
                    }
                    
                    .v-card {
                        display: none;
                    }
                    
                    .font-weight-bold {
                        font-weight: bold;
                    }
                    
                    .w-100 {
                        width: 100%;
                    }
                    
                    .text-center {
                        text-align: center;
                    }
                    
                    .text-left {
                        text-align: left;
                    }
                    
                    .text-right {
                        text-align: right;
                    }
                    
                    .custom-bordered-table {
                        width: 100%;
                        margin-top: 0;
                    }
                    
                    .custom-bordered-table table {
                        width: 100%;
                        border-collapse: collapse;
                        font-size: 11px;
                    }
                    
                    .custom-bordered-table thead {
                        display: table-header-group;
                    }
                    
                    .custom-bordered-table thead th {
                        background-color: #f5f5f5 !important;
                        border: 1px solid #000000 !important;
                        padding: 8px 4px;
                        font-weight: bold;
                        color: #000;
                        vertical-align: middle;
                        -webkit-print-color-adjust: exact;
                        print-color-adjust: exact;
                    }
                    
                    .custom-bordered-table tbody td {
                        border: 1px solid #000000 !important;
                        padding: 6px 4px;
                        vertical-align: middle;
                        color: #000;
                    }
                    
                    .custom-bordered-table tr {
                        page-break-inside: avoid;
                        page-break-after: auto;
                    }
                    
                    .merged-cell {
                        font-weight: 500;
                    }
                    
                    /* Hide pagination and other v-data-table controls */
                    .v-data-table-footer,
                    .v-data-table__wrapper + div,
                    .v-pagination {
                        display: none !important;
                    }
                    
                    @page {
                        size: landscape;
                        margin: 0.5cm;
                    }
                    
                    @media print {
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                            background: white !important;
                            padding: 10px;
                        }
                        
                        .page-header {
                            display: table-header-group;
                        }
                        
                        .custom-bordered-table thead {
                            display: table-header-group;
                        }
                        
                        .custom-bordered-table thead th {
                            background-color: #f5f5f5 !important;
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        
                        .custom-bordered-table tr {
                            page-break-inside: avoid;
                            page-break-after: auto;
                        }
                        
                        table {
                            page-break-inside: auto;
                        }
                    }
                    </style>
                </head>
                <body>
                    <!-- Company Header -->
                    <div class="container-fluid position-relative">
                        <div class="header-section">
                            <div class="company-info">
                                <h4 class="company-name">${companyName}</h4>
                                <p class="company-text">${companyAddress}</p>
                                <p class="company-text">
                                    <span class="mdi mdi-phone-outline"></span>
                                    ${companyMobile}
                                </p>
                                <p class="company-text">
                                    <span class="mdi mdi-email-outline"></span>
                                    ${companyEmail}
                                </p>
                                ${companyWebsite ? `<p class="company-text">
                                    <span class="mdi mdi-web"></span>
                                    ${companyWebsite}
                                </p>` : ''}
                            </div>
                            <div class="logo-container">
                                <img src="${companyLogo}" alt="Company Logo" />
                            </div>
                        </div>
                        
                        <!-- Report Title -->
                        <div class="report-title-section">
                            <h2 class="report-title">Full Payroll Ledger Report</h2>
                        </div>
                        
                        <!-- Report Info -->
                        <div class="report-info">
                            <div class="report-info-right">Total Records: ${this.getSchema.length}</div>
                        </div>
                    </div>
                    
                    <!-- Report Content -->
                    ${printContent}
                </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.moveTo(0, 0);
            printWindow.focus();
            
            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 1000);
        },


        exportToExcel() {
            const data = [
                ["#SL", "Employee Code", "Name", "Designation", "Department", "Gross Salary", "Basic", "Net Payable", "Paid Amount", "Payment Status"]
            ];

            this.getSchema.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.employee.code,
                    item.employee.name,
                    item.designation.name,
                    item.department.name,
                    item.salary_process_detail.gross_salary,
                    item.salary_process_detail.basic,
                    item.salary_process_detail.net_payable,
                    item.salary_process_detail.paid_amount,
                    item.salary_process_detail.payment_status,
                ]);
            });

            this.$exportTableToExcel(data, "salary_pay_register_report_" + this.$fileDate());
        },

        exportToCSV() {
            const data = [
                ["#SL", "Employee Code", "Name", "Designation", "Department", "Gross Salary", "Basic", "Net Payable", "Paid Amount", "Payment Status"]
            ];

            this.getSchema.forEach((item, index) => {
                data.push([
                    index + 1,
                    item.employee.code,
                    item.employee.name,
                    item.designation.name,
                    item.department.name,
                    item.salary_process_detail.gross_salary,
                    item.salary_process_detail.basic,
                    item.salary_process_detail.net_payable,
                    item.salary_process_detail.paid_amount,
                    item.salary_process_detail.payment_status,
                ]);
            });

            this.$exportTableToCSV(data, "salary_pay_register_report_" + this.$fileDate());
        },
    },

    mounted() {
        // this.$refs.searchButton.$el.click();
    },
};
</script> 

<style scoped>
.custom-bordered-table ::v-deep() table {
    border-collapse: collapse;
}

.custom-bordered-table ::v-deep() thead th,
.custom-bordered-table ::v-deep() tbody td {
    border: 1px solid #000000 !important;
    padding: 8px;
}

.custom-bordered-table {
    overflow-x: auto;
    padding: 12px 0;
}

.custom-bordered-table ::v-deep() .merged-cell {
    font-weight: 500;
}

/* Print Styles */
@media print {
    /* Hide unnecessary elements */
    .v-expansion-panel:first-child,
    .v-btn-group,
    .v-navigation-drawer,
    .v-app-bar,
    .v-footer {
        display: none !important;
    }

    /* Expand the report panel */
    .v-expansion-panel-text {
        display: block !important;
        max-height: none !important;
    }

    /* Full width for print */
    .v-container {
        max-width: 100% !important;
        padding: 0 !important;
    }

    /* Table styles for print */
    .custom-bordered-table ::v-deep() table {
        width: 100% !important;
        page-break-inside: auto;
        font-size: 10px;
    }

    .custom-bordered-table ::v-deep() thead {
        display: table-header-group;
    }

    .custom-bordered-table ::v-deep() tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }

    .custom-bordered-table ::v-deep() thead th,
    .custom-bordered-table ::v-deep() tbody td {
        border: 1px solid #000000 !important;
        padding: 6px 4px;
    }

    /* Card title styling */
    .v-card-title {
        background-color: #1976d2 !important;
        color: white !important;
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    /* Remove shadows and elevations */
    .v-card {
        box-shadow: none !important;
    }

    /* Adjust page margins */
    @page {
        margin: 0.5cm;
        size: landscape;
    }
}
</style>